import MailCheck from 'lucide-react/dist/esm/icons/mail-check';

import { cn } from '@/lib/utils';

type AuthStatusMessageProps = {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

/**
 * Confirmation banner for the auth flows that hand the visitor off to their
 * inbox — sign-in links and password resets.
 */
export function AuthStatusMessage({
  title = 'Check your inbox',
  children,
  className
}: AuthStatusMessageProps) {
  return (
    <div
      className={cn(
        'rounded-md border border-success bg-success/10 p-3 text-sm text-success',
        className
      )}
    >
      <div className="flex items-start gap-2">
        <MailCheck className="mt-0.5 size-4" />
        <div className="grid gap-1">
          <p className="font-semibold">{title}</p>
          <p>{children}</p>
        </div>
      </div>
    </div>
  );
}
